import { PRODUCTQTYMINUS, PRODUCTQTYPLUS } from "./actionTypes";

const initialState = [
  {
    id: "item1",
    name: "Asus Vivobook X515MA",
    price: 35500,
    quantity: 20,
  },
  {
    id: "item2",
    name: "Dell E1916HV 18.5 Inch",
    price: 9300,
    quantity: 35,
  },
  {
    id: "item3",
    name: "Canon Eos 4000D 18MP",
    price: 36500,
    quantity: 72,
  },
];

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTQTYPLUS: {
      const updateState = state.map((product) => {
        if (product.id === action.id) {
          return { ...product, quantity: product.quantity + action.value };
        }
        return { ...product };
      });
      console.log(updateState);
      return updateState;
    }
    case PRODUCTQTYMINUS: {
      const updateState = state.map((product) => {
        if (product.id === action.id) {
          return { ...product, quantity: product.quantity - action.value };
        }
        return { ...product };
      });
      return updateState;
    }
    default:
      return state;
  }
};

export default productReducer;
